import { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import EmptyState from '@/components/base/EmptyState';
import ArticleCard from '@/components/base/ArticleCard';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { searchArticles, getHotArticles } from '@/utils/articles';

export default function SearchPage() {
  const [params] = useSearchParams();
  const keyword = params.get('q') || '';
  const results = useMemo(() => searchArticles(keyword), [keyword]);
  const suggestions = getHotArticles(5);

  useDocumentTitle({
    title: keyword ? `搜索「${keyword}」 - 91黑料网` : '搜索 - 91黑料网',
    description: keyword
      ? `91黑料网搜索「${keyword}」的结果，帮你快速找到相关的娱乐黑料、明星爆料与社会热点资讯。`
      : '91黑料网全站搜索，快速找到你关心的黑料与热点。',
    keywords: `${keyword},91黑料网,搜索,黑料资讯,爆料`,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="mx-auto max-w-[1280px] px-4 py-6 md:px-6">
        <Breadcrumb items={[{ label: '搜索结果' }]} />

        <header className="mt-4 animate-fade-up rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <h1 className="text-xl font-black text-foreground-950 md:text-2xl">搜索结果</h1>
          <p className="mt-2 text-sm text-foreground-600">
            {keyword ? (
              <>
                关键词「<span className="font-semibold text-primary-600">{keyword}</span>
                」共找到 {results.length} 条相关爆料
              </>
            ) : (
              '请输入关键词进行搜索。'
            )}
          </p>
        </header>

        <div className="mt-5">
          {results.length > 0 ? (
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
              <div className="flex flex-col gap-3 lg:col-span-2">
                {results.map((item) => (
                  <ArticleCard key={item.id} article={item} />
                ))}
              </div>
              <aside className="lg:col-span-1">
                <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <h3 className="mb-3 flex items-center gap-2 border-b border-background-200 pb-2 text-base font-black text-foreground-950">
                    <i className="ri-fire-fill text-accent-500"></i>
                    大家都在看
                  </h3>
                  <ul className="flex flex-col gap-2.5">
                    {suggestions.map((item, idx) => (
                      <li key={item.id} className="flex items-start gap-2">
                        <span
                          className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded font-label text-xs font-bold ${
                            idx < 3
                              ? 'bg-accent-500 text-background-50'
                              : 'bg-background-200 text-foreground-500'
                          }`}
                        >
                          {idx + 1}
                        </span>
                        <Link
                          to={`/detail/${item.id}`}
                          className="clamp-2 cursor-pointer text-sm leading-snug text-foreground-800 transition-colors hover:text-primary-600"
                        >
                          {item.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </aside>
            </div>
          ) : (
            <EmptyState
              title={keyword ? '没有找到相关爆料' : '还没有输入关键词'}
              description={
                keyword
                  ? '试试更换关键词，例如「塌房」「恋情」「食品安全」，或返回首页浏览最新内容。'
                  : '在顶部搜索框输入关键词，即可检索全站爆料内容。'
              }
            />
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}